import { render, staticRenderFns } from "./cart-with-orders.vue?vue&type=template&id=27eda0da&"
import script from "./cart-with-orders.vue?vue&type=script&lang=js&"
export * from "./cart-with-orders.vue?vue&type=script&lang=js&"
import style0 from "./cart-with-orders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VProgressCircular,VTextarea})
